export default "<div class=\"line-chart__wrapper\">\n  <div class=\"line-chart__content\"></div>\n</div>"